/* This is an autogenerated file, do not modify it. */

import { SubscriptionFilters } from '../sportsbook-api-types';

export enum StreamMessageTypeDto {
	INITIAL_STATE = 'INITIAL_STATE',
	EVENT_ADDED = 'EVENT_ADDED', // Happens only if new event is added
	EVENT_REMOVED = 'EVENT_REMOVED',
	MARKET_ADDED = 'MARKET_ADDED', // Happens only if new market is added
	MARKET_REMOVED = 'MARKET_REMOVED',
	SELECTION_ADDED = 'SELECTION_ADDED', // Happens only if new selection is added
	SELECTION_REMOVED = 'SELECTION_REMOVED',
	EVENT_DELTA = 'EVENT_DELTA',
	MARKET_DELTA = 'MARKET_DELTA',
	SELECTION_DELTA = 'SELECTION_DELTA'
}

export enum PromotionItemType {
	SINGLE = 'Single',
	COMBO = 'Combo',
	LINK = 'Link',
	PRE_CANNED = 'Pre-canned'
}

export enum PromotionItemLinkType {
	CASINO = 'Casino',
	LIVE_CASINO = 'LiveCasino',
	CUSTOM = 'Custom'
}

export enum PromotionItemRestriction {
	AUTHENTICATED_ONLY = 'AUTHENTICATED_ONLY',
	UNAUTHENTICATED_ONLY = 'UNAUTHENTICATED_ONLY'
}

export enum SportradarStreamType {
	DASH_MANIFEST = 'dash-manifest',
	CMAF_MANIFEST = 'cmaf-manifest',
	HLS = 'hls',
	HLS_MANIFEST = 'hls-manifest'
}

export enum ConfigurationSourceType {
	ARLAND = 'ARLAND'
}

export type ArlandConfiguration = {
	nodeId: string;
};

export interface ArlandConfigurationSourceDto extends ConfigurationSourceDto {
	sourceType: ConfigurationSourceType.ARLAND;
	arland: ArlandConfiguration;
}

export interface ConfigurationSourceDto {
	sourceType: ConfigurationSourceType;
}

export type ConfigurationDto = {
	sources: ConfigurationSourceDto[];
	statisticsUrl: string;
	betGeniusGameTrackerBaseUrl: string | null;
};

export const isArlandSource = (source: ConfigurationSourceDto): source is ArlandConfigurationSourceDto =>
	source.sourceType === ConfigurationSourceType.ARLAND;

export type EventMetadata = {
	betBuilderId?: string;
	betBuilderProviderId?: number;
	lugasId?: string;
	sportIcon: string;
};

export enum EventTags {
	MATCH_TRACKER_AVAILABLE = 'MATCH_TRACKER_AVAILABLE',
	HAS_BET_BUILDER = 'HAS_BET_BUILDER',
	HAS_PRE_CANNEDS = 'HAS_PRE_CANNEDS',
	HAS_REVERSED_ORDER = 'HAS_REVERSED_ORDER',
	HAS_SUPER_SUB = 'HAS_SUPER_SUB'
}

export type EventDto = {
	id: string;
	externalId: string;
	type: string;
	eventName: string;
	sportId: string;
	sportName: string;
	externalSportId: string;
	regionId: string;
	regionCode: string;
	regionName: string;
	leagueId: string;
	leagueName: string;
	startingOn: string;
	liveGameState?: LiveGameStateDto;
	status: string;
	isLive: boolean;
	betslipLine: string;
	leagueOrder: number;
	sportOrder: number;
	isSuspended: boolean;
	lastUpdatedOn: string;
	participants: ParticipantDto[];
	eventScore: EventScoreDto;
	metadata: EventMetadata;
	tags: EventTags[];
	mediaProviders?: MediaProviderDto[];
	marketGroups: MarketGroupDto[];
	primaryParticipants: ParticipantsMap;
	secondaryParticipants: ParticipantsMap;
};

// EventScore

export enum ScoreDisplayType {
	TOTAL = 'TOTAL',
	PERIOD = 'PERIOD'
}

export enum PeriodScoreTags {
	PERIOD_WINNER = 'PERIOD_WINNER',
	SERVING = 'SERVING',
	ADVANTAGE = 'ADVANTAGE'
}

export type PeriodScore = {
	primaryScore: number | null;
	secondaryScore: number | null;
	tags: PeriodScoreTags[];
};

export type ParticipantScoreDto = {
	score: number | null;
	secondaryScore: number | null;
	periodScores: PeriodScore[];
};

export type EventScoreDto = {
	eventScoreDisplayType: ScoreDisplayType;
	inlineDisplayType: ScoreDisplayType;
	homeScore: ParticipantScoreDto;
	awayScore: ParticipantScoreDto;
};

export type GroupDto = {
	sortingKey: number;
	id: string;
};

export type LeagueFilterDto = {
	franchiseCode: string;
	sportId: string;
	leagueIds: Array<string>;
	locale: string;
	isLive: boolean;
	isOutrightsOnlyLeague: boolean;
	startingAfter: string;
	startingBefore: string;
};

export enum LeagueTags {
	TOURNAMENT_PREVIEW_ELIGIBLE = 'TOURNAMENT_PREVIEW_ELIGIBLE'
}

export type LeagueDto = {
	id: string;
	externalId: string;
	name: string;
	leagueOrder: number;
	isTopLeague: boolean;
	isOutrightsOnlyLeague: boolean;
	eventCount: number;
	liveEventCount: number;
	sportId: string;
	sportName: string;
	regionId: string;
	regionCode: string;
	regionName: string;
	lastUpdatedOn: string;
	tags: Array<LeagueTags>;
	sportIcon: string;
};

export type LiveGameStateDto = {
	clockRunning: boolean;
	clockDirection: string;
	gameTime: number;
	periodEndTime: number;
	periodId: string;
	periodName: string;
	periodType: PeriodType;
	overtimeClockBehaviour: OvertimeClockBehaviour;
	clockType: ClockType;
	periodLength: number;
	gamePeriod: number;
};

export enum ClockType {
	Stopwatch = 'Stopwatch',
	Timer = 'Timer'
}

export enum OvertimeClockBehaviour {
	ContinueCounting = 'ContinueCounting',
	StopCounting = 'StopCounting'
}

export enum PeriodType {
	Regular = 'Regular',
	ExtraTime = 'ExtraTime',
	Penalties = 'Penalties',
	Break = 'Break',
	Other = 'Other'
}

export type MarketMetadata = {
	sortingKey: number;
	liveSortingKey: number;
};

export enum MarketTags {
	IS_SECRET = 'IS_SECRET',
	IS_PREFERRED = 'IS_PREFERRED'
}

export enum MarketGroupTags {
	IS_PLAYER_PROPS = 'IS_PLAYER_PROPS',
	IS_PRECANNED = 'IS_PRECANNED',
	LABEL_NEW = 'LABEL_NEW'
}

export type MarketDto = {
	id: string;
	externalId: string;
	name: string;
	eventId: string;
	isSuspended: boolean;
	tags: MarketTags[];
	marketType: MarketTypeDto;
	metadata: MarketMetadata;
	inMarketGroups: GroupDto[];
};

export type MarketGroupDto = {
	id: string;
	externalId: string;
	name: string;
	order: number;
	marketsCount: number;
	tags: MarketGroupTags[];
};

export enum MarketTypeLayout {
	DEFAULT = 'DEFAULT',
	MERGED = 'MERGED',
	MERGED_TABLE = 'MERGED_TABLE',
	PRE_CANNED = 'PRE_CANNED',
	INTEGER_OUTCOME_TABLE = 'INTEGER_OUTCOME_TABLE',
	PLAYER_PROPS = 'PLAYER_PROPS'
}

export type SelectionsTemplate = Array<{
	id: string;
	name: string;
	order: number;
}>;

export type MarketTypeDto = {
	id: string;
	externalId: string;
	name: string;
	originalName: string | null;
	marketTypeLayout: MarketTypeLayout;
	selectionsTemplate: SelectionsTemplate;
	isBetBuilder: boolean;
	isPreCanned: boolean;
};

export enum MediaProviderName {
	IMG = 'IMG',
	PERFORM = 'Perform',
	SPORTRADAR = 'BetRadarV3',
	BETGENIUS = 'BetGenius'
}

export enum EventMediaProviderMediaType {
	MATCH_TRACKER = 'MatchTracker',
	MATCH_PREVIEW = 'MatchPreview',
	LIVESTREAMING = 'LiveStreaming',
	GAME_TRACKER = 'GameTracker'
}

export type MediaProviderDto<T = EventMediaProviderMediaType> = {
	providerName: MediaProviderName;
	providerEventId: string;
	mediaType: T;
	blockedCountryCodes: string[];
};

export type BetGeniusStreamingConfigurationDto = {
	widgetLoaderUrl: string;
	customerId: string;
};

export type BetGeniusStreamingDataDto = {
	url: string;
	expiresAt: string;
	token: string;
	drm: BetGeniusStreamingDataDrmDto;
};

export type BetGeniusStreamingDataDrmDto = {
	widevine: string;
	playready: string;
	fairplay: string;
	fairplayCertificate: string;
};

export type ParticipantDto = {
	id: string;
	externalId: string;
	name: string;
	venueRole: string;
	eventId: string;
	country: string;
	metadata: { [key: string]: string };
	jerseys: Array<JerseyDto>;
};

export type JerseyDto = {
	baseColor: string;
	sleeveColor: string;
	sleeveDetailColor: string;
	numberColor: string;
	pattern: JerseyPattern;
	typeString: 'home' | 'away';
	shirtType: string;
	teamProfileId: number;
};

export enum JerseyPattern {
	NONE = 'None',
	STRIPES = 'Stripes',
	SQUARES = 'Squares',
	HORIZONTAL_STRIPES = 'HorizontalStripes',
	SPLIT = 'Split'
}

export type ParticipantsMap = Record<string, ParticipantDto | null>;

export enum PromotionItemSource {
	INHOUSE = 'INHOUSE',
	PRECANNED = 'PRECANNED'
}

export type PromotionItemDto = {
	id: string;
	orderNumber: number;
	type: PromotionItemType;
	source: PromotionItemSource;
	eventIds?: string[];
	marketIds?: string[];
	sportId?: string;
	selectionIds?: string[];
	linkType: PromotionItemLinkType;
	titleTextKey: string;
	descriptionTextKey: string;
	backgroundImageUrl: string;
	backgroundImageResourceKey: string;
	linkTextKey: string;
	restrictions: Array<PromotionItemRestriction>;
	linkUrl: string;
};

export type SelectionDto = {
	id: string;
	externalId: string;
	outcomeType?: string;
	name: string;
	trueOdds: number;
	points: number;
	marketId: string;
	marketTypeId: string;
	isSecret: boolean;
	status: string;
	betslipLine: string;
	externalEventId: string;
	eventId: string;
	order: number | null;
	templateId: string;
	primaryParticipantId: string;
	secondaryParticipantId: string;
};

export type SportDto = {
	id: string;
	name: string;
	order: number;
	liveEventCount: number;
	lastUpdatedOn: string;
	isOutrightOnly: boolean;
	icon: string;
};

export type StreamMessageDto = {
	type: StreamMessageTypeDto;
	payload: StreamMessagePayloadDto;
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type StreamMessagePayloadDto = {};

export type StreamMessagePayloadEventRemovedDto = {
	eventId: string;
};

export type StreamMessagePayloadEventUpdatedDto = {
	event: EventDto;
};

export type StreamMessagePayloadInitialStateDto = {
	events: EventDto[];
	markets: MarketDto[];
	selections: SelectionDto[];
	page: number;
	pageSize: number;
	totalPageCount: number;
	requestedFromApi: string;
	createdByApi: string;
};

export type StreamMessagePayloadMarketRemovedDto = {
	marketId: string;
};

export type StreamMessagePayloadMarketUpdatedDto = {
	market: MarketDto;
};

export type StreamMessagePayloadSelectionRemovedDto = {
	selectionId: string;
};

export type StreamMessagePayloadSelectionUpdatedDto = {
	selection: SelectionDto;
};

// Since e.g EventDto.EventScoreDto is also a partial, we need to make EventDto a deep partial.
export type RecursivePartial<T> = {
	[P in keyof T]?: RecursivePartial<T[P]>;
};
type PartialExcept<T, K extends keyof T> = RecursivePartial<T> & Pick<T, K>;

// id field always exists
export type EventDelta = PartialExcept<EventDto, 'id'>;
export type MarketDelta = PartialExcept<MarketDto, 'id'>;
export type SelectionDelta = PartialExcept<SelectionDto, 'id'>;

// The StreamMessageTypeDto tells you if it is an event, market or selection delta contained in the `delta` property.
export type StreamMessagePayloadDeltaDto = {
	delta: EventDelta | MarketDelta | SelectionDelta;
};

export type TimestampDto = {
	receivedInConsumer: string;
	receivedInApi: string;
	sentFromApi: string;
};

export type SelectionReferenceDto = {
	referenceId: string;
	selectionId: string;
};

export enum FeaturedContentTypeDto {
	LIVE = 'LIVE',
	UPCOMING = 'UPCOMING',
	HOT_LIVE = 'FEATURED_LIVE',
	HOT_UPCOMING = 'FEATURED_UPCOMING',
	PRE_CANNED = 'PRE_CANNED'
}

type FeaturedContentFilters = SubscriptionFilters & {
	metadata: {
		eventCount: number;
	};
};

export type FeaturedContentDto = {
	type: FeaturedContentTypeDto;
	filters: Array<FeaturedContentFilters>;
};

export type FeaturedPreCannedItemDto = {
	eventId: string;
	marketId: string;
	selectionId: string;
};

export enum RecommendedBetTypeDto {
	SINGLE = 'SINGLE'
}

export type RecommendedBetItemDto = {
	event: EventDto;
	market: MarketDto;
	selection: SelectionDto;
};

export type RecommendedBetDto = {
	type: RecommendedBetTypeDto;
	odds: number;
	items: RecommendedBetItemDto[];
};

export type SportPreferredMarketTypeDto = {
	marketNameTextKey: string;
	marketTypeIds: string[];
	points: number | null;
	isPreferredMarket: boolean;
};

type MarketTypeFilterDto = {
	isPreferredMarket: boolean;
	marketTypeIds: string[];
	points: number | null;
};

export type MatchBetDto = {
	marketTypeFilter: MarketTypeFilterDto;
	sortOrder: number;
};

export type SearchResultDto = {
	events: EventDto[];
	leagues: LeagueDto[];
	metadata: {
		sportIds: string[] | null;
		defaultMarketTypes: Record<string, SportPreferredMarketTypeDto>;
		defaultMarketTypesBySportId: Record<
			string,
			Array<Pick<SportPreferredMarketTypeDto, 'marketTypeIds' | 'points' | 'isPreferredMarket'>>
		>;
		searchId: string | null;
	} | null;
};

export enum OptixTrackSearchRefType {
	EVENT = 'event',
	MARKET = 'market',
	SELECTION = 'selection',

	/** Translating to Optix naming conventions as they differ from what we usually call these entities */
	LEAGUE = 'type',
	REGION = 'class',
	SPORT = 'category'
}

export type OptixTrackSearchResultRequest = {
	ranking: number;
	query: string;
	searchId: string;
	/** Event, market or selection id of the relevant entity */
	refId: string;
	/** Type of item that was clicked - selection, market, event, type (league), class (region) or category (sport) */
	refType: OptixTrackSearchRefType;
	timestamp: string;
	anonymousId: string;
};

export enum QuickLinkTypeDto {
	CUSTOM = 'CUSTOM',
	SPORT = 'SPORT',
	LEAGUE = 'LEAGUE'
}

export type QuickLinkDto = {
	id: number;
	order: number;
	icon: string;
	type: QuickLinkTypeDto;
	labelTextKey: string;
	url: string;
	sportId: string;
	sportName: string;
	leagueId: string;
	leagueName: string;
	labelName: string | undefined;
	isFeatured: boolean;
};
